import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, Renderer2, ViewChild } from '@angular/core';
import { previewDocument } from './agent-action-card';

// Exact e-mail of one recipient (03-APPROBATION §6, 06-FRONT §5.2): the HTML rendered by the server, untouched, in an
// iframe with an empty sandbox (no script, no same origin, no form, no popup, no top navigation) and a policy that
// blocks remote images. The document is set as an attribute of the iframe, never in the page itself, so Angular's
// sanitizer (which would rewrite the e-mail) is not involved and nothing of the e-mail runs in Aglo.
@Component({
  selector: 'app-agent-mail-preview',
  standalone: true,
  template: '<iframe #frame class="mail-frame" sandbox="" referrerpolicy="no-referrer" [title]="label"></iframe>',
  styles: [':host { display: block; } .mail-frame { display: block; width: 100%; height: 420px; border: 0; background: #FFFFFF; } @media (max-width: 480px) { .mail-frame { height: 360px; } }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentMailPreviewComponent implements OnChanges, AfterViewInit {
  @Input() html = '';
  @Input() label = 'Aperçu de l’e-mail';
  @ViewChild('frame') frame?: ElementRef<HTMLIFrameElement>;

  constructor(private renderer: Renderer2) {}

  ngOnChanges() { this.write(); }
  ngAfterViewInit() { this.write(); }

  private write() {
    const frame = this.frame?.nativeElement;
    if (frame) this.renderer.setAttribute(frame, 'srcdoc', previewDocument(this.html));
  }
}
